import "./checkbox-v2.css";

import { FC } from "react";
import { twMerge } from "tailwind-merge";
import { CheckboxV2Type } from "./checkbox-v2.types";

export const CheckBoxV2: FC<CheckboxV2Type> = ({
  label,
  id: idProp,
  onChange,
  className,
  checked,
}) => {
  const inputId = idProp ?? label;
  return (
    <div className={twMerge("flex items-center", className)}>
      <div
        className="flex items-center"
        style={{ flexDirection: "row", gap: "8px", alignItems: "center" }}
      >
        <input
          type="checkbox"
          id={inputId}
          checked={checked}
          style={{
            display: "flex",
            width: "17px",
            height: "17px",
            alignItems: "center",
            gap: "10px",
            flexShrink: "0",
            marginTop: 0,
          }}
          onChange={(e) => {
            if (onChange) {
              e.stopPropagation();
              onChange(e.target.checked);
            }
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
        <label
          htmlFor={inputId}
          style={{ margin: 0, marginBottom: "1px", cursor: "pointer" }}
        >
          {label}
        </label>
      </div>
    </div>
  );
};
